import { useClaimNumbers } from './use-claim-numbers';
import { ClaimNumbersModal } from './components/claim-numbers-modal';

export function ClaimNumbersView() {
  const { claimModal, availableRewardCount, prefill, resetPrefill } = useClaimNumbers();

  if (!claimModal?.open) return null;
  return <ClaimNumbersModal availableRewardCount={availableRewardCount} prefill={prefill} onClaimed={resetPrefill} />;
}
